export const routesConfig = [
  {
    path: '/',
    component: 'Dashboard',
  },
  {
    path: '/profile',
    component: 'Profile',
  },
  {
    path: '/cto',
    component: 'Cto/index',
  },
  {
    path: '/cto/create',
    component: 'Cto/CtoCreate',
  },
  {
    path: '/cto/read/:id',
    component: 'Cto/CtoRead',
  },
  {
    path: '/cto/update/:id',
    component: 'Cto/CtoUpdate',
  },

  // {
  //   path: '/chief',
  //   component: 'Chief/index',
  // },
  // {
  //   path: '/chief/create',
  //   component: 'Chief/ChiefCreate',
  // },
  // {
  //   path: '/chief/read/:id',
  //   component: 'Chief/ChiefRead',
  // },
  // {
  //   path: '/chief/update/:id',
  //   component: 'Chief/ChiefUpdate',
  // },
  {
    path: '/subworkstream',
    component: 'Subworkstream/index',
  },
  {
    path: '/subworkstream/create',
    component: 'Subworkstream/SubworkstreamCreate',
  },
  {
    path: '/subworkstream/read/:id',
    component: 'Subworkstream/SubworkstreamRead',
  },
  {
    path: '/subworkstream/update/:id',
    component: 'Subworkstream/SubworkstreamUpdate',
  },
  {
    path: '/subworkstream/:workstreamId',
    component: 'Subworkstream/ReadSubworkstream',
  },

  {
    path: '/workstream',
    component: 'Workstream/index',
  },
  {
    path: '/workstream/create',
    component: 'Workstream/WorkstreamCreate',
  },
  {
    path: '/workstream/read/:id',
    component: 'Workstream/WorkstreamRead',
  },
  {
    path: '/workstream/update/:id',
    component: 'Workstream/WorkstreamUpdate',
  },
  {
    path: '/workstream/:chiefId',
    component: 'Workstream/ReadWorkstream',
  },
  {
    path: '/sector',
    component: 'Sector/index',
  },
  {
    path: '/sector/create',
    component: 'Sector/WorkstreamCreate',
  },
  {
    path: '/sector/read/:id',
    component: 'Sector/WorkstreamRead',
  },
  {
    path: '/sector/update/:id',
    component: 'Sector/WorkstreamUpdate',
  },
  {
    path: '/subsector',
    component: 'Subsector/index',
  },
  {
    path: '/subsector/create',
    component: 'Subsector/WorkstreamCreate',
  },
  {
    path: '/subsector/read/:id',
    component: 'Subsector/WorkstreamRead',
  },
  {
    path: '/subsector/update/:id',
    component: 'Subsector/WorkstreamUpdate',
  },

  {
    path: '/strategy',
    component: 'Strategy/index',
  },
  {
    path: '/strategy/create',
    component: 'Strategy/StrategyCreate',
  },
  {
    path: '/strategy/read/:id',
    component: 'Strategy/StrategyRead',
  },
  {
    path: '/strategy/update/:id',
    component: 'Strategy/StrategyUpdate',
  },
  {
    path: '/strategy/:strategyId',
    component: 'Strategy/ReadStrategy',
  },
  {
    path: '/requirement',
    component: 'Requirement/index',
  },
  {
    path: '/requirement/create',
    component: 'Requirement/RequirementCreate',
  },
  {
    path: '/requirement/read/:id',
    component: 'Requirement/RequirementRead',
  },
  {
    path: '/requirement/update/:id',
    component: 'Requirement/RequirementUpdate',
  },
  {
    path: '/requirement/:chiefId',
    component: 'Requirement/ReadRequirement',
  },

  {
    path: '/delegate',
    component: 'Delegation/index',
  },
  {
    path: '/delegate/create',
    component: 'Delegation/DelegationCreate',
  },
  {
    path: '/delegate/read/:id',
    component: 'Delegation/DelegationRead',
  },
  {
    path: '/delegate/update/:id',
    component: 'Delegation/DelegationUpdate',
  },
  {
    path: '/request',
    component: 'Request/index',
  },
  {
    path: '/request/create',
    component: 'Request/RequestCreate',
  },
  {
    path: '/request/read/:id',
    component: 'Request/RequestRead',
  },
  {
    path: '/request/update/:id',
    component: 'Request/RequestUpdate',
  },
  {
    path: '/request/:userId',
    component: 'Request/RequestRead',
  },
  {
    path: '/user',
    component: 'User/index',
  },
  {
    path: '/user/create',
    component: 'User/UserCreate',
  },
  {
    path: '/user/read/:id',
    component: 'User/UserRead',
  },
  {
    path: '/user/update/:id',
    component: 'User/UserUpdate',
  },
  {
    path: '/workstreamaction',
    component: 'Workstreamaction/index',
  },
  {
    path: '/workstreamaction/create',
    component: 'Workstreamaction/WorkstreamactionCreate',
  },
  {
    path: '/workstreamaction/read/:id',
    component: 'Workstreamaction/WorkstreamactionRead',
  },
  {
    path: '/workstreamaction/update/:id',
    component: 'Workstreamaction/WorkstreamactionUpdate',
  },
  {
    path: '/workstreamaction/:userId',
    component: 'Workstreamaction/WorkstreamactionRead',
  },

  {
    path: '/initiative',
    component: 'Initiative/index',
  },
  {
    path: '/initiative/create',
    component: 'Initiative/InitiativeCreate',
  },
  {
    path: '/initiative/read/:id',
    component: 'Initiative/InitiativeRead',
  },
  {
    path: '/initiative/update/:id',
    component: 'Initiative/InitiativeUpdate',
  },

  {
    path: '/initiative/update/:id/impacts',
    component: 'Impact/index',
  },
  {
    path: '/initiative/update/:id/milestones',
    component: 'Impact/index',
  },

  {
    path: '/initiative/:id',
    component: 'InitiativeTodo/TodoRead',
  },

  {
    path: '/Initiative/report/:id',
    component: 'InitiativeTodo/TodoReport',
  },

  {
    path: '/role',
    component: 'Role/index',
  },
  {
    path: '/role/create',
    component: 'Role/RoleCreate',
  },
  {
    path: '/role/read/:id',
    component: 'Role/RoleRead',
  },
  {
    path: '/role/update/:id',
    component: 'Role/RoleUpdate',
  },
  {
    path: '/report',
    component: 'Report/index',
  },
  {
    path: '/report/create',
    component: 'Report/ReportCreate',
  },
  {
    path: '/generalReport',
    component: 'GeneralReport/index',
  },
  {
    path: '/generalReport/create',
    component: 'GeneralReport/GeneralReportCreate',
  },
  {
    path: '/generalReport/read/:id',
    component: 'GeneralReport/GeneralReportRead',
  },
  {
    path: '/generalReport/update/:id',
    component: 'GeneralReport/GeneralReportUpdate',
  },
];
